import React, { Component } from 'react';
import './Checkbox.css'

class Checkbox extends Component {

    toggleChecked = () => {
        this.props.handleChange(this.props.id)
    }


    checked = () => {
        
    }

    render() {

        return(
            <span className="Checkbox switch__container">
                    <input id="switch-flat" className="switch switch--flat" type="checkbox" defaultChecked={this.props.active} onChange={this.change}/>
                    {/* <label htmlFor="switch-flat" className={this.props.active ? 'active' : ''} onClick={this.toggleChecked} ></label> */}
                    <label htmlFor="switch-flat" className={this.props.active ? 'active' : ''} ></label>

            </span>
        )
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox.js